<template>
  <div
    v-if="value"
    class="flex flex-col mb-2 hover:text-blue-600"
    :data-testid="`field-${fieldKey}`"
  >
    <span
      class="font-semibold text-university-primary"
      :data-testid="`label-${fieldKey}`"
    >
      {{ label }}
    </span>
    <span
      class="text-university-primary cursor-pointer transition-all"
      :data-testid="`value-${fieldKey}`"
      @click="() => formattedValue && copyToClipboard(formattedValue)"
    >
      {{ formattedValue }}
    </span>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useToast } from "vue-toast-notification";

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  value: {
    type: [String, Number, Date, Array],
    default: null,
  },
  fieldKey: {
    type: String,
    required: true,
  },
  formatType: {
    type: String,
    default: "text",
  },
  locale: {
    type: String,
    default: "en-US",
  },
});

const toast = useToast();

const formattedValue = computed(() => {
  if (props.formatType === "date" && props.value) {
    return new Date(props.value).toLocaleDateString(props.locale, {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }
  return props.value;
});

const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text).then(() => {
    toast.info(`"${text}" copied to clipboard!`, {
      position: "top-right",
      duration: 2000,
    });
  });
};
</script>
